import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

export const tablePanelTabsSx: SxProps<Theme> = {
  pl: s('sm'),
  '& .MuiTabs-indicator': {
    height: '1px',
  },
};

export const tablePanelTabSx: SxProps<Theme> = {
  fontSize: '16px',
  lineHeight: 1.3,
};

export const inertTablePanelTabSx: SxProps<Theme> = [
  tablePanelTabSx,
  {
    cursor: 'default',
    pointerEvents: 'none',
  },
];
